<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 보호구 지급 및 관리 현황 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="방호장치 현황"
      title-type="hint"
      hint="유해·위험 기계·기구(방호장치)"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', placeholder: '내용', width: '50px' },
        { id: 'input2', title: '대상기계', type: 'text', placeholder: '내용' },
        {
          id: 'input3',
          title: '방호장치',
          type: 'select',
          selectData: [
            '예초기',
            '원심기',
            '공기압축기',
            '금속절단기',
            '지게차',
            '진공포장기, 래핑기',
            '휴대용연삭기 및 연삭기',
          ],
          placeholder: '선택',
        },
      ]"
      :mobile="['no', 'input2', 'input3']"
      v-model="form.equipList"
      @input="inputEquip"
      @openPopup="openPopup"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 팝업 -->
    <vs-popup id="popAlert" title="유해·위험 기계·기구(방호장치)" :active.sync="showPopup">
      <table id="PopupTable" style="margin-bottom: 20px">
        <tr>
          <th>유해·위험 기계·기구(방호장치)</th>
        </tr>
        <tr>
          <td class="p-3">
            <div style="padding: 0 10px">
              <p class="mb-1">1. 예초기(날접촉 예방장치)</p>
              <p class="mb-1">2. 원심기(회전체 접촉 예방장치)</p>
              <p class="mb-1">3. 공기압축기(압력방출장치)</p>
              <p class="mb-1">4. 금속절단기(날접촉 예방장치)</p>
              <p class="mb-1">5. 지게차(헤드 가드, 백 레스트, 전조등, 안전벨트, 후방경보음)</p>
              <p class="mb-1">6. 진공포장기, 래핑기(구동부 방호 연동장치)</p>
              <p class="mb-1">7. 휴대용연삭기 및 연삭기(안전커버)</p>
            </div>
          </td>
        </tr>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        equipList: [ { "id": 1, "input2": "", "input3": "예초기" } ],
        photoList: [],
        fileList: [],

        targets: "",
        protectors: "",
      },
    };
  },
  methods: {
    inputEquip(v) {
      this.form.targets = v.map((item) => item.input2).join(", ");
      this.form.protectors = v.map((item) => item.input3).join(", ");
    },
    openPopup() {
      this.showPopup = true;
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}
</style>
